import React, { createContext, useContext, useState, useEffect } from 'react';

const defaultFlags = {
  isConsentEnabled: false,
  isAutoConfirmFlow: false,
  isOnlyInDetail: false,
  executiveRut: '27',
  sellerRut: '19',
  dealerRut: '797917303',
  storeCode: '1',
  storeCodeMeli: '13',
  storeCodeTwoSteps: '1',
};

const FeatureFlagsContext = createContext({
  flags: defaultFlags,
  isLoadingFlags: true,
});

export const FeatureFlagsProvider = ({ children }) => {
  const [flags, setFlags] = useState(defaultFlags);
  const [isLoadingFlags, setIsLoadingFlags] = useState(true);

  useEffect(() => {
    const fetchFlags = async () => {
      try {
        const timestamp = new Date().getTime();
        const response = await fetch(`/config.json?t=${timestamp}`);
        if (response.ok) {
          const data = await response.json();
          setFlags(data);
        }
      } catch (error) {
      } finally {
        setIsLoadingFlags(false);
      }
    };

    fetchFlags();
  }, []);

  return (
    <FeatureFlagsContext.Provider value={{ flags, isLoadingFlags }}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagsContext);
